import { render, staticRenderFns } from "./ModalCreateProject.vue?vue&type=template&id=16cba1f8&scoped=true&"
import script from "./ModalCreateProject.vue?vue&type=script&lang=js&"
export * from "./ModalCreateProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cba1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16cba1f8')) {
      api.createRecord('16cba1f8', component.options)
    } else {
      api.reload('16cba1f8', component.options)
    }
    module.hot.accept("./ModalCreateProject.vue?vue&type=template&id=16cba1f8&scoped=true&", function () {
      api.rerender('16cba1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalCreateProject.vue"
export default component.exports